<template>
  <div id="product">
    <section class="bg-cl-primary px20 product-top-section">
      <div class="container">
        <section class="row content_justify m0">
          <div class="col-xs-12 col-md-12 p0">
            <breadcrumbs
              class="pt20 cl-silver"
            />
          </div>
          <div class="col-xs-12 cl-light-gray col-md-8 center-xs middle-xs pt20 image relative p0">
            <product-gallery
              :stylist-notes="getCurrentProduct.stylists_notes"
              :stylist-header="getAllAttributeList('stylists_notes')"
              :offline="getOfflineImage"
              :gallery="getProductGallery"
              :large="getProductLargeGallery"
              :vimeo-id="getCurrentProduct.vimeo_id"
              :configuration="getCurrentProductConfiguration"
              :product="getCurrentProduct"
            />
          </div>
          <div class="col-xs-12 col-md-4 pl30 data">
            <configurable-product v-if="getCurrentProduct.type_id === 'configurable' || getCurrentProduct.type_id === 'sirent'" />
            <simple-product v-else-if="getCurrentProduct.type_id === 'simple'" />
            <shipping-payment-section :product-type="getCurrentProduct.type_id" />
            <product-tabs-desktop-info v-if="getCurrentProduct.stylists_notes" :title="getAllAttributeList('stylists_notes')" :description="getCurrentProduct.stylists_notes" />
            <product-tabs-desktop-info v-if="getCurrentProduct.editors_notes" :title="getAllAttributeList('editors_notes')" :description="getCurrentProduct.editors_notes" />
            <product-tabs-desktop-info v-if="getCurrentProduct.fabric && !isSimple" :title="getAllAttributeList('fabric')" :description="getCurrentProduct.fabric" />
            <product-tabs-desktop-info :title="isSimple ? $t('Buy risk-free') : $t('Rent no risk')" :description="isSimple 
              ? `Wszystkie produkty dostępne w E-Garderobe przechodzą szczegółowy proces weryfikacji prowadzony przez naszych ekspertów. Zanim zostaną opublikowane na stronie, trafiają bezpośrednio do butiku E-Garderobe, gdzie dedykowany zespół dokładnie sprawdza ich autentyczność, stan zachowania oraz kompletność.

                Weryfikujemy dokumentację, oryginalne opakowania oraz wszystkie istotne informacje dotyczące produktu, aby zapewnić naszym klientom pełne bezpieczeństwo zakupów i najwyższy standard jakości. Dzięki temu masz pewność, że każdy przedmiot dostępny w E-Garderobe jest starannie sprawdzony i gotowy, by rozpocząć swoją kolejną historię.`
              : $t('All the garments at E-Garderobe are without any damages or stains. We always double check quality of our garments before shipping the package. E-Garderobe team makes sure that all rental garments are in perfect condition to meet with customer expectation. All the garments are insured in case of accidental damage or stain.')"
            />
            <product-tabs-desktop-info :title="$t('Shipment or pickup')" :description="isSimple 
              ? `Wszystkie wysyłki realizujemy od poniedziałku do piątku za pośrednictwem kuriera DHL. Każda paczka jest ubezpieczona, a numer śledzenia przesyłki otrzymasz w wiadomości e-mail po nadaniu zamówienia.

                Wszystkie zakupione przez Ciebie produkty wysyłamy w ciągu 24 godzin od momentu złożenia zamówienia. Zamówienia opłacone do godziny 13:00 wysyłane są jeszcze tego samego dnia roboczego. Odbiór osobisty zakupionego produktu możliwy jest jeszcze tego samego dnia.

                Zapraszamy do odbioru w naszym butiku w Warszawie:
                ul. Piękna 11A, 00-549 Warszawa.

                Godziny otwarcia:
                poniedziałek – piątek: 11:00–19:00
                sobota: 12:00–16:00`
              : `Jeśli jesteś z Warszawy, serdecznie zapraszamy do naszego butiku przy ul. Pięknej 11A (00-549). Na przymiarki nie musisz się umawiać — możesz odwiedzić nas w dogodnym dla siebie momencie w godzinach naszego otwarcia. 
                Dla klientek spoza Warszawy oferujemy wysyłkę na terenie całej Polski. Zamówienia złożone do godziny 14:00 nadajemy jeszcze tego samego dnia, dzięki czemu przesyłka dociera zazwyczaj w kolejnym dniu roboczym.
                Jeśli pilnie potrzebujesz kreacji i mieszkasz poza Warszawą, skontaktuj się z nami telefonicznie pod numerem 698 136 499 — postaramy się znaleźć najszybsze możliwe rozwiązanie.
                Przesyłki realizowane są za pośrednictwem firmy DHL. Szczegółowe informacje dotyczące daty oraz godziny doręczenia otrzymasz bezpośrednio od firmy kurierskiej w wiadomości e-mail oraz SMS.
                Nie ponosimy odpowiedzialności za opóźnienia w dostawie wynikające z działania firmy kurierskiej.`"
            />
            <product-tabs-desktop-info :title="isSimple ? $t('Returns') : $t('Returns and exchanges')" :description="isSimple
              ? `Produkty zakupione w E-Garderobe można zwrócić w ciągu 14 dni kalendarzowych od momentu doręczenia przesyłki. Zwracane przedmioty nie mogą nosić śladów użytkowania i powinny zostać odesłane lub zwrócone osobiście do naszego butiku. Towar należy zwrócić w stanie nienaruszonym, z zachowanymi (nieruszonymi) zabezpieczeniami E-Garderobe. Zwrot osobisty jest możliwy w naszym butiku przy ul. Pięknej 11A, 00-549 Warszawa. Środki za zwrócony produkt zostaną odesłane na pierwotną formę płatności w ciągu 14 dni od momentu przyjęcia zwrotu.`
              : `Jeśli zamówiona kreacja nie spełnia Twoich oczekiwań lub nie pasuje, prosimy o odesłanie przesyłki w ciągu 24 godzin od momentu jej otrzymania do najbliższego punktu DHL w Twoim mieście.
                Zwrot środków realizujemy w formie karty podarunkowej do wykorzystania przy kolejnym wypożyczeniu. Nie dokonujemy zwrotów pieniężnych.
                Zwracana kreacja musi posiadać komplet zabezpieczeń oraz metek i nie może nosić śladów użytkowania. Zamówienia na 1 dzień nie podlegają wymianie ani zwrotowi. 
                Jeśli wypożyczona kreacja nie odpowiada Ci rozmiarem lub stylem, możesz ją również wymienić na inny model, rozmiar albo przełożyć termin wypożyczenia ( dla wypożyczeń na 4 lub 7 dni). W tym celu odeślij kreację w ciągu 24 godzin i skontaktuj się z nami, aby wybrać nową opcję pod nr tel +48 698 136 499
                Zamiast wypożyczaj bez ryzyka - Wypożyczaj bez stres
                Kreacje E-Garderobe są starannie sprawdzane, nie posiadają wad i są gotowe do założenia. Każda kreacja przed wysyłką jest dokładnie wyprana, wyprasowana i przygotowana tak, abyś mogła założyć ją od razu po otrzymaniu. Dbamy o najwyższą jakość naszych rzeczy oraz pełne zadowolenie klientek.
                Każda kreacja w ramach wypożyczenia jest objęta ubezpieczeniem, dlatego nie musisz martwić się drobnymi zabrudzeniami czy niewielkimi uszkodzeniami — ubezpieczenie pokrywa drobne naprawy.`"
            />
            <product-tabs-desktop-info :title="$t('Help')" :description="isSimple 
              ? `Jeśli masz pytania dotyczące produktu lub zakupów na naszej platformie, skontaktuj się z naszym Biurem Obsługi Klienta pod numerem +48 698 136 499. Jesteśmy do Twojej dyspozycji od poniedziałku do piątku w godzinach 11:00–19:00 oraz w soboty w godzinach 12:00–16:00.
                Jeśli jesteś w Warszawie, zapraszamy również do naszego butiku E-Garderobe, gdzie możesz zobaczyć wszystkie produkty dostępne na naszej platformie:
                ul. Piękna 11A, Warszawa.`
              : `Nie jesteś pewna rozmiaru i nie możesz odwiedzić naszego butiku w Warszawie? Zamów przymiarkę do domu jeszcze przed wypożyczeniem kreacji. Przymiarki wysyłkowe realizujemy w każdą środę — wybrane modele dostarczane są bezpośrednio pod Twoje drzwi za pośrednictwem kuriera DHL.
                Jeśli jesteś z Warszawy, możesz bezpłatnie przymierzyć dostępne kreacje w naszym butiku. Nasze stylistki pomogą Ci dobrać idealny model dopasowany do sylwetki i okazji. Zapraszamy pod adres: ul. Piękna 11A, 00-549 Warszawa. Nasz butik jest czynny od poniedziałku do piątku od 11:00 do 19:00 w sobotę od 12:00 do 16:00. 
                Potrzebujesz pomocy ? Skontaktuj się z nami telefonicznie w godzinach otwarcia pod numerem +48 698 136 499 `"
            />
          </div>
          <div class="col-xs-12 data-mobile visible-xs">
            <div
              class="cl-primary variants visible-xs"
              v-if="getCurrentProduct.type_id =='configurable'"
            >
              <p class="error" v-if="getCurrentProduct.errors && Object.keys(getCurrentProduct.errors).length > 0">
                {{ getCurrentProduct.errors | formatProductMessages }}
              </p>
              <!-- <related-small type="related" :current-product="getCurrentProduct.image" class="" v-if="getCurrentProduct.product_links" /> -->
            </div>
          </div>
        </section>
        <modal-size :modal-size="true" :name="'modal-size'">
          <div slot="header capitalize">
            {{ $t('size guide') }}
          </div>
          <div slot="content" class="table-box">
            <p v-html="sizeGuideTable" />
          </div>
        </modal-size>
      </div>
    </section>
    <div
      v-observe-visibility="{
        callback: visibilityChanged,
        once: true
      }"
    >
      <related-products v-if="seen" type="related" class="pt50 mobile-padding" :heading="$t('Put on with')" :category-id="getFirstClothesChild" />
      <div class="py10" id="7c47852c-7389-4494-ac11-dee2660aea37" />
      <script defer type="application/javascript" :src="`https://trustmate.io/api/widget/7c47852c-7389-4494-ac11-dee2660aea37/script?product=${getCurrentProduct.parentSku}`" />
      <related-products v-if="seen" type="crosssell" class="pt50" :heading="$t('Similar products')" :category-id="getFirstClothesChild" />
    </div>
    <div class="pb40" />
    <product-meta :product="getCurrentProduct" :aggregate-rating="reviewStar" :review-count="reviewCount" :review-arr="reviewArr" :gallery="getUniqProductGallery" />
    <calendar-modal />
    <h1 v-if="getCurrentProduct.instagram_id" class="instagram-title">
      {{ $t('See on instagram') }}
    </h1>
    <div class="pb30" v-if="getCurrentProduct.instagram_id">
      <script src="https://apps.elfsight.com/p/platform.js" type="application/javascript" defer />
      <div :class="'elfsight-app-' + getCurrentProduct.instagram_id + ' container instagram-width'" />
    </div>
    <subscription-modal />
  </div>
</template>

<script>
import config from 'config'
import { vueVimeoPlayer } from 'vue-vimeo-player'
import RelatedProducts from 'theme/components/core/blocks/Product/Related.vue'
import Breadcrumbs from 'theme/components/core/Breadcrumbs.vue'
import ProductGallery from 'theme/components/core/ProductGallery'
import focusClean from 'theme/components/theme/directives/focusClean'
import { mapGetters } from 'vuex'
import { getAvailableFiltersByProduct, getSelectedFiltersByProduct } from '@vue-storefront/core/modules/catalog/helpers/filters'
import { isOptionAvailableAsync } from '@vue-storefront/core/modules/catalog/helpers/index'
import { localizedRoute, currentStoreView } from '@vue-storefront/core/lib/multistore'
import { htmlDecode } from '@vue-storefront/core/filters'
import { catalogHooksExecutors } from '@vue-storefront/core/modules/catalog-next/hooks'
import ProductTabsDesktopInfo from 'theme/components/core/blocks/Product-v2/ProductTabsDesktopInfo.vue'
import ProductMeta from 'theme/components/core/blocks/Product/ProductMeta.vue'
import ModalSize from '../components/core/Modal-size.vue'
import { getThumbnailPath as _thumbnailHelper, onlineHelper, isServer } from '@vue-storefront/core/helpers'
import { categoryResolver } from 'theme/helpers/categoryResolverFunction'
import NoSSR from 'vue-no-ssr'
import ConfigurableProduct from 'theme/components/core/blocks/Product-v2/ConfigurableProduct.vue'
import SimpleProduct from 'theme/components/core/blocks/Product-v2/SimpleProduct.vue'
import CalendarModal from 'theme/components/core/blocks/Product-v2/CalendarModal.vue'
import { registerModule } from '@vue-storefront/core/lib/modules'
import { RecentlyViewedModule } from '@vue-storefront/core/modules/recently-viewed'
import { InstantCheckoutModule } from 'src/modules/vsf-instant-checkout'
import SubscriptionModal from 'theme/components/core/blocks/Product-v2/Rent/components/SubscriptionModal.vue'
import ShippingPaymentSection from 'theme/components/core/blocks/Product-v2/ShippingPaymentSection.vue'

export default {
  components: {
    ModalSize,
    Breadcrumbs,
    ProductGallery,
    ProductTabsDesktopInfo,
    RelatedProducts,
    ProductMeta,
    vueVimeoPlayer,
    'no-ssr': NoSSR,
    ConfigurableProduct,
    SimpleProduct,
    CalendarModal,
    SubscriptionModal,
    ShippingPaymentSection
  },
  directives: { focusClean },
  data () {
    return {
      seen: false,
      reviewStar: 0,
      reviewCount: 0,
      reviewArr: [],
      isStockInfoLoading: false,
      maxQuantity: 0
    }
  },
  async asyncData ({ store, route }) {
    const product = await store.dispatch('product/loadProduct', { parentSku: route.params.parentSku, childSku: route && route.params && route.params.childSku ? route.params.childSku : null })
    const loadBreadcrumbsPromise = store.dispatch('product/loadProductBreadcrumbs', { product })
    if (isServer) await loadBreadcrumbsPromise
    catalogHooksExecutors.productPageVisited(product)
  },
  beforeRouteEnter (to, from, next) {
    if (isServer) {
      next()
    } else {
      next((vm) => {
        vm.$store.commit('ui/routeChanged', { to: to, from: from })
        vm.setAvaliableSourceCodes()
        vm.$store.dispatch('stock/getQuantity')
      })
    }
  },
  beforeCreate () {
    registerModule(RecentlyViewedModule)
    registerModule(InstantCheckoutModule)
  },
  beforeMount () {
    this.$bus.$on('product-after-load', this.addRecentlyViewed)
  },
  created () {
    if (this.getCurrentProduct.product_promo_type) {
      window.setInterval(this.autoIncrementTimer, 1000)
    }
  },
  async mounted () {
    await this.$store.dispatch('recently-viewed/addItem', this.getCurrentProduct)
  },
  beforeDestroy () {
    this.$bus.$off('product-after-load', this.addRecentlyViewed)
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct',
      getProductGallery: 'product/getProductGallery',
      getProductLargeGallery: 'product/getProductLargeGallery',
      getCurrentProductConfiguration: 'product/getCurrentProductConfiguration',
      attributesByCode: 'attribute/attributeListByCode',
      isVirtualInCart: 'cart/isVirtualInCart'
    }),
    getFirstClothesChild () {
      let categoryResolverResult = categoryResolver(this.getCurrentProduct.category, this.$store, config.server.categoryIdsMap.rootCategoryId)
      let firstClothesChild = categoryResolverResult.categoriesIdsFromResolver.length && categoryResolverResult.categoriesIdsFromResolver[0]
      firstClothesChild = firstClothesChild && firstClothesChild.split('/')
      return firstClothesChild && firstClothesChild.length ? Number(firstClothesChild[firstClothesChild.length - 1]) : config.server.categoryIdsMap.rootCategoryId
    },
    designerCheck () {
      return this.getLabelFor('designer') ? this.getLabelFor('designer') : ''
    },
    getMainCategory () {
      return this.getMenuCategories.find(cat => cat.id === config.server.categoryIdsMap.mainCategoryId)
    },
    attrs () {
      return [
        {
          highlight: {
            start: { color: 'blue', fillMode: 'solid' },
            base: { color: 'blue', fillMode: 'light' },
            end: { color: 'blue', fillMode: 'solid' }
          },
          dates: { start: this.getFirstAvaliableDate, span: 1 }
        }
      ]
    },
    sizeGuideTable () {
      return this.validBaners['size_guide'] && this.getCurrentProduct.size_guide
        ? this.validBaners['size_guide'].content
        : ''
    },
    validBaners () {
      return this.$store.state.cmsBlock.baners
    },
    storeView () {
      return currentStoreView()
    },
    isSimple () {
      return this.getCurrentProduct.type_id === 'simple'
    },
    getUniqProductGallery () {
      return this.getProductGallery.reduce((unique, item) => unique.find(elem => elem.src === item.src)
        ? unique
        : [...unique, item], [])
    },
    hostName () {
      return config.server.hostName
    },
    getOfflineImage () {
      return {
        src: this.getThumbnail(this.getCurrentProduct.image, config.products.thumbnails.width, config.products.thumbnails.height),
        error: this.getThumbnail(this.getCurrentProduct.image, config.products.thumbnails.width, config.products.thumbnails.height),
        loading: this.getThumbnail(this.getCurrentProduct.image, config.products.thumbnails.width, config.products.thumbnails.height)
      }
    },
    getAvailableFilters () {
      return getAvailableFiltersByProduct(this.getCurrentProduct)
    },
    listByCode () {
      return this.$store.state.attribute.list_by_code
    }
  },
  methods: {
    // need refactor - duplicate method
    // async getQuantity () {
    //   if (this.isStockInfoLoading) return // stock info is already loading
    //   this.isStockInfoLoading = true
    //   try {
    //     const res = await this.$store.dispatch('stock/check', {
    //       product: this.getCurrentProduct,
    //       qty: this.getCurrentProduct.qty
    //     })
    //     this.maxQuantity = res.qty
    //   } finally {
    //     this.isStockInfoLoading = false
    //   }
    // },
    // need refactor - duplicate method
    setAvaliableSourceCodes () {
      if (this.getCurrentProduct.type_id !== 'configurable' && this.getCurrentProduct.type_id !== 'sirent') return
      if (this.getCurrentProduct.stock && this.getCurrentProduct.stock.source_codes && this.getCurrentProduct.stock.source_codes.length) {
        this.$store.commit('calendar/setAvailableDeliveries', this.getCurrentProduct.stock.source_codes)
      } else {
        this.$store.commit('calendar/setAvailableDeliveries', [])
      }
      this.$store.dispatch('calendar/loadCalendarData', { sku: this.getCurrentProduct.sku })
    },
    async addRecentlyViewed () {
      this.$store.dispatch('recently-viewed/addItem', this.getCurrentProduct)
    },
    getLocaleByStoreId (storeId) {
      for (let storeCode of config.storeViews.mapStoreUrlsFor) {
        if (!config.storeViews[storeCode]) continue
        if (config.storeViews[storeCode].storeId === Number(storeId)) {
          return [
            true,
            config.storeViews[storeCode].i18n.defaultLocale,
            config.storeViews[storeCode].url
          ]
        }
      }
      return [false, null, null]
    },
    getThumbnailPath (url, width, height) {
      return _thumbnailHelper(url, width, height, 'product')
    },
    visibilityChanged (isVisible) {
      if (isVisible && !this.seen) {
        this.seen = true
      }
    },
    getLabelFor (type) {
      if (this.listByCode && this.listByCode[type]) {
        let items = this.listByCode[type].options.filter((option) => { return option.value === String(this.getCurrentProduct[type]) })
        if (items && items.length) {
          return items[0].label
        } else {
          return false
        }
      }
    },
    getAllAttributeList (value) {
      return this.attributesByCode[value] ? this.attributesByCode[value].frontend_label : 'Product info Tab'
    },
    onReady () {
      this.playerReady = true
    },
    isOptionAvailable (option) { // check if the option is available
      const currentConfig = Object.assign({}, this.getCurrentProductConfiguration)
      currentConfig[option.type] = option
      return isOptionAvailableAsync(this.$store, { product: this.getCurrentProduct, configuration: currentConfig })
    }
  },
  metaInfo () {
    let link = []
    let alternates = {}
    for (let storecode of Object.keys(this.getCurrentProduct.store_view_urls)) {
      const storeId = storecode && storecode.split('_')[1]
      if (!storeId) continue
      let [ok, locale, url] = this.getLocaleByStoreId(storeId)
      if (!ok || locale === config.storeViews[this.$store.state.storeView.storeCode].i18n.defaultLocale) continue
      let hreflang = locale === 'en-US' ? 'x-default' : locale
      alternates[hreflang] = {
        rel: 'alternate',
        hreflang: hreflang,
        href: config.server.hostName + url + '/' + this.getCurrentProduct.store_view_urls[`store_${storeId}`]
      }
    }
    link = Object.values(alternates)
    if (Object.keys(this.$route.params).length > 1) {
      link.push({
        rel: 'canonical',
        href: config.server.hostName + this.$route.path
      })
    }
    return {
      htmlAttrs: { lang: config.storeViews[this.$store.state.storeView.storeCode].i18n.defaultLocale },
      link,
      title: htmlDecode(this.getCurrentProduct.meta_title || this.getCurrentProduct.name),
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.getCurrentProduct.meta_description ? htmlDecode(this.getCurrentProduct.meta_description) : htmlDecode(this.getCurrentProduct.description).replace(/<[^>]+>/g, ' ').replace(/\s{2,10}/g, ' ')
        },
        {
          property: 'og:type',
          content: 'product'
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: this.getCurrentProduct.meta_title ? htmlDecode(this.getCurrentProduct.meta_title) : htmlDecode(this.getCurrentProduct.name)
        },
        {
          vmid: 'og:locale',
          property: 'og:locale',
          content: this.$store.state.storeView.storeCode ? config.storeViews[this.$store.state.storeView.storeCode].i18n.defaultLocale : ''
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.getCurrentProduct.meta_description ? htmlDecode(this.getCurrentProduct.meta_description) : htmlDecode(this.getCurrentProduct.description).replace(/<[^>]+>/g, ' ').replace(/\s{2,10}/g, ' ')
        },
        {
          vmid: this.getCurrentProduct.url_path ? 'og:url' : '',
          property: this.getCurrentProduct.url_path ? 'og:url' : '',
          content: this.getCurrentProduct.url_path ? htmlDecode(config.server.hostName + '/' + this.getCurrentProduct.url_path) : ''
        },
        {
          vmid: this.getCurrentProduct.image ? 'og:image' : '',
          property: this.getCurrentProduct.image ? 'og:image' : '',
          content: this.getCurrentProduct.image ? this.getThumbnailPath(this.getCurrentProduct.image, 1200, 1200) : ''
        },
        {
          property: 'og:image:width',
          content: '1200'
        },
        {
          property: 'og:image:height',
          content: '1200'
        },
        {
          property: this.getLabelFor('designer') ? 'og:brand' : '',
          content: this.getLabelFor('designer') ? this.getLabelFor('designer') : ''
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-primary: color(primary);
$color-tertiary: color(tertiary);
$color-secondary: color(secondary);
$color-white: color(white);
$bg-secondary: color(secondary, $colors-background);

.add-to-cart-mobile {
  padding: 10px 40px;
}
.product {
  &__add-to-compare {
    display: none;
    @media (min-width: 767px) {
      display: block;
    }
  }
}
.error {
  color: red;
  font-weight: bold;
  // padding-bottom: 15px;
}
.instagram-title {
  margin-top: 25px;
  font-size: 40px;
  font-weight: 500;
  text-align: center;
  @media (max-width: 767px) {
    font-size: 26px;
  }
}
.mobile-video-padding {
  padding-bottom: 150%;
}
.data {
  position: -webkit-sticky;
  position: sticky;
  background-color: white;
  top: 120px;
  padding-top: 20px;
  align-self: flex-start;
  @media (max-width: 767px) {
    order: 1;
    padding-left: 25px;
    padding-right: 24px;
  }
}
.vimeo-video {
  /deep/ iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
}
.data-mobile {
  ::-webkit-scrollbar {
    width: 0px !important;
    height: 0px !important;
  }
  .scroll-attributes::-webkit-scrollbar { width: 0 !important }
  .scroll-attributes
  {
    overflow-x: scroll;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    display: flex;
    overflow-x: scroll;
  }
  @media (max-width: 767px) {
    order: 3;
  }
}
.breadcrumbs {
  @media (max-width: 767px) {
    margin: 15px 0;
    padding: 15px 0 0 15px;
    order:0;
    font-size: 12px;
    padding-left: 8px;
    margin: 0px;
    white-space: nowrap;
    overflow: hidden;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
    flex-wrap: nowrap !important;
  }
}
.author {
  font: normal normal normal 14px/28px Poppins;
}
.image {
  @media (max-width: 1023px) {
    // margin-bottom: 20px;
  }
}
.instagram-width {
  width: 75% !important;
}
.modal-size-button {
  text-decoration: underline;
  display: flex;
  align-items: flex-end;
  justify-content: start;
  padding-bottom: 7px;
  color: #000000;
  font-size: 12px;
}

.price {
  @media (max-width: 767px) {
    // color: $color-primary;
    margin-top: 10px;
    margin-bottom: 0;
  }
  .special-price {
    @media (max-width: 767px) {
      margin: 0;
      span {
        padding-left: 0;
      }
    }
  }
}
.variants-label {
  @media (max-width: 767px) {
    font-size: 14px;
  }
}
.container {
  @media (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
}
.imformation-covid {
  margin-top: 20px;
  border-top: 1px solid black;
}
.product-top-section {
  @media (max-width: 767px) {
    padding: 0;
    background-color: $color-white;
  }
}

.price-original {
  text-decoration: line-through;
}

.web-share {
  float: right;
}
.content_justify {
  justify-content: center;
}
.apple-pay-butt {
  padding: 0;
  display: flex;
  height: 45px;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
  background-color: white;
  color: #000000;
  border: 1px solid #000000;
}
@media (min-width: 1024px) and (max-width: 1420px) {
  .image {
    flex-basis: 58.33333333%;
    max-width: 58.33333333%;
    .size-box {
      flex-basis: 19%;
      max-width: 19%;
    }
  }
}
.word-nowrap {
  white-space: nowrap;
}
.promoted-badge {
  margin-bottom: 10px;
  margin-left: 0;
  margin-right: 0;
  justify-content: space-between;
  .counter {
    color: white;
    background-color: #000;
    border-radius: 30px 0 0 30px;
    display: flex;
    justify-content: center;
    padding-left: 30px;
    flex-direction: column;
  }
  .promoted-countdown {
    margin: 0;
  }
  .promoted-title {
    font-size: 18px;
    text-transform: uppercase;
    color: white;
    padding-left: 20px;
    font-weight: 400;
    letter-spacing: 1px;
  }
}

.twisto-baner {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
}
/deep/ .spinner {
  width: 20px !important;
  height: 20px !important;
  display: flex;
  align-items: center;
}
</style>
